import { useState } from 'react';

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems = [
    {
      q: 'Is Consentry built specifically for the DPDP Act, 2023?',
      a: "Yes — designed from the first line of code for the Indian DPDP Act, not adapted from a GDPR product. We use the Act's exact terminology: data principal, data fiduciary, notice, purpose. Consent capture, notice versioning, and audit trails are modeled directly on Sections 5–8, and are updated as the Data Protection Board issues guidance.",
    },
    {
      q: 'What happens to my consent records if Consentry shuts down?',
      a: 'All consent records are exportable as portable JSON at any time, from any plan, with no data lock-in. You own the data. In the event Consentry ceases operations, you receive 90 days\' notice, full export access, and a final compliance certificate covering all recorded data. This is a contractual commitment, not a policy.',
    },
    {
      q: 'Can Consentry employees read our consent records?',
      a: 'No. Consent record access requires a valid API key scoped to your organisation. Consentry engineers do not have standing access to customer consent data. Access to production infrastructure requires a formal change request and produces an audit log entry. We can provide this access policy in writing for enterprise compliance reviews.',
    },
    {
      q: 'Can I self-host?',
      a: 'The hosted platform is the primary offering, running on Indian regional infrastructure. Enterprise customers with specific data residency requirements can discuss private deployment options — contact us before evaluating alternatives.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="relative py-28 px-6 lg:px-8">
      {/* Visual connector line */}
      <div className="sc" aria-hidden="true">
        <svg width="2" height="24" viewBox="0 0 2 24">
          <line x1="1" y1="0" x2="1" y2="24" className="sc-line" stroke="#2563EB" strokeOpacity="0.3" strokeWidth="1.5" />
        </svg>
        <span className="sc-node" />
      </div>

      <div className="max-w-2xl mx-auto">
        <h2 className="text-[32px] sm:text-[38px] font-extrabold tracking-tight text-ink mb-12 text-center">
          Questions worth answering honestly.
        </h2>

        <div className="space-y-3">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className="border border-line rounded-xl2 overflow-hidden bg-card transition-colors">
                <button
                  type="button"
                  onClick={() => toggleFAQ(idx)}
                  className="w-full flex items-center justify-between text-left px-5 py-4 text-[14px] font-medium text-ink hover:text-blue transition-colors cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span>{item.q}</span>
                  <svg
                    className={`w-4 h-4 text-muted shrink-0 transition-transform duration-300 ${
                      isOpen ? 'rotate-180 text-blue' : 'rotate-0'
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-[13.5px] text-sub leading-relaxed animate-log-slide">
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
